import React from 'react'
import ContactPage from '../components/Contact/ContactPage'

const Contact = () => {
  return (
<main>
  <ContactPage/>
</main>
  )
}

export default Contact
